interface LocationCardProps {
  name?: string;
  streetAddress?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  className?: string;
}

export function LocationCard({ name, streetAddress, city, province, postalCode, className }: LocationCardProps) {
  const addressLine = [streetAddress, city, province].filter(Boolean).map(s => String(s).trim()).join(', ');

  return (
    <div className={`p-4 shadow-sm border-0 card h-100 ${className ?? ''}`}>
      <p className="text-muted small text-uppercase fw-semibold mb-2">
        <i className="fa fa-map-marker me-2"></i>Location
      </p>
      {name && <p className="fw-semibold mb-1">{name}</p>}
      {addressLine && <p className="text-muted small mb-0">{addressLine}</p>}
      {postalCode && <p className="text-muted small mb-0">{postalCode}</p>}
    </div>
  );
}
